import type { ComponentProps, FC } from 'react'
import SearchSm from '@sylveraio/untitled-ui-icons-react/build/esm/SearchSm'
import XClose from '@sylveraio/untitled-ui-icons-react/build/esm/XClose'
import { Button } from '../Button'
import clsx from 'clsx'

export type SearchProps = {
  size?: 'sm' | 'lg'
  onClear?: () => void
} & Omit<ComponentProps<'input'>, 'size'>

export const Search: FC<SearchProps> = ({
  size = 'lg',
  onClear,
  ...rest
}: SearchProps) => (
  <div className="relative w-full">
    <div
      className={clsx('absolute left-0 top-0', {
        'p-3': size === 'lg',
        'p-2': size === 'sm',
      })}
    >
      <SearchSm
        className={clsx('text-subtle', {
          'h-6 2-6': size === 'lg',
          'h-5 w-5': size === 'sm',
        })}
      />
    </div>

    <input
      type="search"
      className={clsx(
        'rounded-lg border border-default text-sm text-default outline-0 ring-content-action-subtle ring-offset-2 placeholder:text-subtle hover:border-default-hover hover:bg-high-hover focus-visible:border-content-action-default focus-visible:ring-4 w-full',
        {
          'h-9 pl-9 pr-10': size === 'sm',
          'h-12 pl-10 pr-11': size === 'lg',
        },
      )}
      {...rest}
    />

    {typeof rest.value === 'string' && rest.value.length > 0 && (
      <div
        className={clsx('absolute right-0 top-0', {
          'py-0.5 px-1': size === 'sm',
          'p-1': size === 'lg',
        })}
      >
        <Button
          iconLeading={<XClose />}
          onClick={onClear}
          size={size === 'lg' ? 'md' : 'xs'}
          variant="subtle"
        />
      </div>
    )}
  </div>
)
